var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeviceAndTechnologyDesktop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-3880.000000, -839.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Device-and-technology/Desktop",
    transform: "translate(3880.000000, 839.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4219,27.8019869 C19.0339,27.8019869 21.4379,28.6399895 23.4219,30.0349939 L23.4219,30.0349939 L23.4219,32 L9.4219,32 L9.4219,30.0349939 C11.4079,28.6399895 13.8099,27.8019869 16.4219,27.8019869 Z M32,-1.42108547e-14 L32,21.0000656 C32,23.2090725 30.209,25.0000781 28,25.0000781 L28,25.0000781 L0,25.0000781 L0,4.0000125 C0,1.79000559 1.791,-1.42108547e-14 4,-1.42108547e-14 L4,-1.42108547e-14 L32,-1.42108547e-14 Z M29,3.00000938 L3,3.00000938 L3,20.0000625 L29,20.0000625 L29,3.00000938 Z",
    id: 122
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceAndTechnologyDesktop);
export default __webpack_public_path__ + "static/media/device-and-technology-desktop.922faf67.svg";
export { ForwardRef as ReactComponent };